import React from 'react';
import { validateByJoi } from '../utilities/validation';
import * as _ from 'lodash';
import _slideLoader from '../utilities/slideLoader';
import EventMg from '../utilities/EventManager';
import moment from 'moment';
import Helmet from 'react-helmet';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  WORKER_TYPES, // 契約状態
  // REQUEST_PARAMS, // API定数
  SCHEDULE_STATUS, // 予定実績フラグ
  SYSTEM_WORKER_COUNT, // 時間
  WORK_EARLY_OVER_TYPES, // 早出残業フラグ
  WORK_HOUR_ZONES, // 作業時間帯
  HEADER_CONSTANTS, // ヘッダータイトル
  KEY_MESSAGES_REQUIRE_INPUT_PLACE,
  UPDATE_DATE,
  NUMBER_OF_FIELD_ITEM_TYPE,
  CONST_ABCD__PLACE_AND_SUB_WORK,
  REQUIRE_WORK_PLACE,
  FIELD_ITEM_LISTS,
} from '../utilities/constants';

import { LatestCopy } from './modals/Commons'; // 前回コピー
import dialogLoader from '../utilities/dialogLoader';
import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { FieldItemService } from '../services/FieldItems'; // 現場作業エリア情報取得API
import { FieldImageService } from '../services/FieldImages';
import { WorkScheduleService } from '../services/Works'; // 作業予定API
import { CompanyBranchService } from '../services/CompanyBranches'; // 入力項目管理リストAPI
import { WorkScheduleForm } from '../components/forms/WorkSchedule'; // フォーム
import dayWorkerFormSchema from '../utilities/validationSchemas/dayWorker';
import workRegisterFormSchema from '../utilities/validationSchemas/workRegister';
import workRegisterDefaultState from '../utilities/workRegisterDefaultState';
import { messageUtility } from '../utilities/messageUtility';
import { stringToNumber, deleteControlCode } from '../utilities/stringUtil';
import { getDisplayedCompanyName } from '../utilities/getDisplayedCompanyName';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import ClipLoader from 'react-spinners/ClipLoader';
import { ConferencePageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import ProgressService from '../services/Progress';
import { SptService } from '../services/Spt';
import { isPrimeContractorHasBlockedOrFinishedWorkError } from '../utilities/apiErrorMessage';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { Confirmation } from '../components/modals/common';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';

const MY_EVENT = {
  LOAD_GROUP_DATA: 'load_group_data', // 一覧取得
};

/**
 * 「作業予定一覧＆作業実績一覧」共通・新規登録
 *
 * @export
 * @class WorkRegister
 * @extends {React.Component}
 */
export class WorkRegister extends React.Component {
  constructor(props) {
    super(props);

    // 1-3は支店項目優先
    this.optionListNumbers = [
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
    ];
    this.state = workRegisterDefaultState(this.props);

    this.fieldId = SessionStorageService.getFieldId();
    this.listHistoriesMain = null;
    this.listHistoriesSub = null;
    this.isFirstTimeGetHistories = true;
    this.temporaryWorkPlaceRequireType = null;
    this.events = {
      dialog: {
        showCopy: this.handleCopyDialog.bind(this), // コピー
        showContinuity: this.handleContinuityDialog.bind(this), // 続けて登録
        copy: this.getLatestSchedule.bind(this), // コピー
        goBack: this.handleGoBackDialog.bind(this), // 戻る
      },
      form: {
        set: this.setFlatData.bind(this), // 入力
        dropdown: this.setDropdownData.bind(this), // ドロップダウン選択
        keyplan: this.setDropdownKeyplanData.bind(this), // キープラン選択
        set15Time: this.set15Time.bind(this), // 15分単位で計算
        submit: this.eventSubmit.bind(this), // 登録
        latest: this.getLatestSchedule.bind(this), // 前回コピー
        calender: this.setDate.bind(this), // 期間選択
        deleteKeyPlan: this.deleteKeyPlan.bind(this), // キープラン削除
        setEditKeyplanFlag: this.setEditKeyplanFlag.bind(this), // キープラン編集済みフラグ
        validate: this.validateValue.bind(this), // バリデーション
        workDayTime: {
          // 人工
          set: this.setWorkDayTime.bind(this), // 入力
          add: this.addWorkDayTime.bind(this), // 追加
          remove: this.removeWorkDayTime.bind(this), // 削除
        },
        earlyOverTime: {
          // 早出残業
          set: this.setEarlyOverTime.bind(this), // 入力
          add: this.addEarlyOverTime.bind(this), // 追加
          remove: this.removeEarlyOverTime.bind(this), // 削除
        },
      },
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.getOvertimeStart = this.getOvertimeStart.bind(this); // 早出開始時間計算
    this.getEarlytimeEnd = this.getEarlytimeEnd.bind(this); // 残業終了時間計算
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視
    this.checkEarlyOverTimes = this.checkEarlyOverTimes.bind(this); // 早出・残業入力判定

    // 人工バリデーション Schema
    this.dayWorkerSchema = dayWorkerFormSchema;
    this.submitRef = React.createRef(); // 登録ボタン要素
    this.submitContinueRef = React.createRef(); // 続けて登録ボタン要素

    // 前回コピー
    this.LatestCopy = {
      callback: {
        copy: () => {
          this.getLatestSchedule();
          dialogLoader.close();
        },
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
          _slideLoader.close(this.props.vw);
          dialogLoader.close();
        },
      },
    };
    this.setLoadedKeyPlanData = this.setLoadedKeyPlanData.bind(this);
    this.updateKeyPlan = this.updateKeyPlan.bind(this);
  }

  componentDidMount() {
    this.getSptLinkageSetting();
    ProgressService.getProgressFieldSettings(this.state.fieldId).then(
      async responseFieldSettings => {
        if (
          responseFieldSettings.result &&
          _.get(responseFieldSettings, 'data.entities.progress_field_settings')
        ) {
          const responseFieldMainWork = await ProgressService.getProgressFieldMainWorkTypes(
            this.state.fieldId,
            {
              limit: 1,
              include_other_flag: 1,
            }
          );
          this.setState(
            {
              progress_date_from: _.get(
                responseFieldSettings,
                'data.entities.progress_field_settings.input_start_date'
              ),
              progress_date_to: _.get(
                responseFieldSettings,
                'data.entities.progress_field_settings.input_end_date'
              ),
              lengthOfListMainWorkTypes:
                _.get(responseFieldMainWork, 'data.total') || 0,
            },
            () => {
              this.setVisibleMainSubWorkDropdown(
                UPDATE_DATE.all_work_date,
                this.state.formValues.work_date_from,
                this.state.formValues.work_date_to
              );
            }
          );
        }
      }
    );

    // 項目カスタマイズAPI
    CompanyBranchService.companyItemOrders(this.state.fieldId).then(
      response => {
        if (response.result) {
          const companyItemOrders = _.get(
            response,
            'data.entities.company_item_orders'
          );
          this.setState({
            companyItemOrders,
          });
        }
      }
    );
    // システム管理者からのデーター取得
    CompanyBranchService.companyItemSettings(this.state.fieldId).then(
      response => {
        if (response.result) {
          let companyItemSettings =
            response.data.entities.company_item_settings;
          let formValues = this.state.formValues;

          if (_.isEmpty(companyItemSettings)) {
            alert('データを取得できませんでした。');
            console.error('データ取得失敗：company_item_settings');
            return;
          }
          const option1 = _.find(companyItemSettings, {
            item_name: 'item_1',
          });
          const option2 = _.find(companyItemSettings, {
            item_name: 'item_2',
          });
          const option3 = _.find(companyItemSettings, {
            item_name: 'item_3',
          });
          if (option1) {
            option1.item_display_flag === 1
              ? (formValues.option1_must_flag = option1.item_must_flag)
              : (formValues.option1_must_flag = 0);
          }
          if (option2) {
            option2.item_display_flag === 1
              ? (formValues.option2_must_flag = option2.item_must_flag)
              : (formValues.option2_must_flag = 0);
          }
          if (option3) {
            option3.item_display_flag === 1
              ? (formValues.option3_must_flag = option3.item_must_flag)
              : (formValues.option3_must_flag = 0);
          }

          // 項目カスタマイズで「必須」に設定された項目をrequiredInput.columnsに追加
          let requiredInput = this.state.requiredInput;
          if (formValues.option1_must_flag === 1) {
            requiredInput.columns.push('option1');
          }
          if (formValues.option2_must_flag === 1) {
            requiredInput.columns.push('option2');
          }
          if (formValues.option3_must_flag === 1) {
            requiredInput.columns.push('option3');
          }

          // 必須要件の合計をrequiredInput.totalに設定する
          requiredInput.total = requiredInput.columns.length;
          this.setState({ companyItemSettings, formValues, requiredInput });
          this.checkRequired(formValues);
        }
      }
    );

    // 現場情報取得
    FieldService.fieldItem(this.state.fieldId).then(response => {
      if (response.result) {
        let formValues = this.state.formValues;
        const item_list_ids = [1, 2, 3, 4];
        let fieldItem = response.data.entities.field_item;
        _.each(this.optionListNumbers, num => {
          // 項目設定数より大きい場合は必須フラグは見ない
          if (num > fieldItem.create_item_count) {
            return;
          }
          fieldItem[`option${num}_display_flag`] === 1
            ? (formValues[`option${num}_must_flag`] =
                fieldItem[`option${num}_must_flag`] || 0)
            : (formValues[`option${num}_must_flag`] = 0);
        });
        let requiredInput = this.state.requiredInput;

        _.each(this.optionListNumbers, num => {
          if (
            formValues[`option${num}_must_flag`] === 1 &&
            // 項目設定数より大きい場合は必須項目としない
            num <= fieldItem.create_item_count
          ) {
            requiredInput.columns.push(`option${num}`);
          }
        });
        _.map(item_list_ids, (itemListId, key) => {
          if (fieldItem[`field_item_list${itemListId}_display_flag`] === 0) {
            item_list_ids.splice(key, 1);
          }
        });
        if (item_list_ids.length > 0) {
          const params = {
            item_list_ids,
            is_limit: 1,
            offset: 0,
            limit: 30,
            // 有効のものだけ表示
            display_flag: 1,
          };

          // 現場作業エリア情報取得API
          FieldItemService.list(this.state.fieldId, params).then(response => {
            if (response.result === false) {
              return;
            }

            this.setState({
              options: response.data.entities,
            });
          });
        }

        // 必須要件の合計をrequiredInput.totalに設定する
        requiredInput.total = requiredInput.columns.length;
        this.setState({ requiredInput, fieldItem }, () => {
          // 現場情報の取得(単一レコード)
          FieldService.info(this.state.fieldId).then(response => {
            if (response.result) {
              const field = response.data.entities.field;
              let workHour = '';
              if (_.size(field.work_hour) === 1) {
                workHour = field.work_hour[0];
              } else {
                let pasts = [];
                let futures = [];
                _.each(field.work_hour, workTime => {
                  if (
                    moment(workTime.start_date).isSameOrBefore(
                      moment(this.state.formValues.work_date_from)
                    )
                  ) {
                    pasts.push(moment(workTime.start_date, 'YYYY-MM-DD'));
                  } else {
                    futures.push(moment(workTime.start_date, 'YYYY-MM-DD'));
                  }
                });
                let found = [];
                if (_.isEmpty(pasts)) {
                  found = _.filter(field.work_hour, {
                    start_date: moment.min(futures).format('YYYY-MM-DD'),
                  });
                } else {
                  found = _.filter(field.work_hour, {
                    start_date: moment.max(pasts).format('YYYY-MM-DD'),
                  });
                }
                workHour = found[0];
              }
              let workTime = this.state.workTime;
              workTime[WORK_HOUR_ZONES.day.id] = _.assign(
                workTime[WORK_HOUR_ZONES.day.id],
                { start: field.work_start_time }
              ); // 労働開始時刻（昼）
              workTime[WORK_HOUR_ZONES.day.id] = _.assign(
                workTime[WORK_HOUR_ZONES.day.id],
                { end: field.work_end_time }
              ); // 労働終了時刻（昼）
              workTime[WORK_HOUR_ZONES.day.id] = _.assign(
                workTime[WORK_HOUR_ZONES.day.id],
                { working_time: workHour.worker_work_time }
              ); // 作業時間
              workTime[WORK_HOUR_ZONES.day.id] = _.assign(
                workTime[WORK_HOUR_ZONES.day.id],
                {
                  earlytime_end: field.earlytime_end
                    ? field.earlytime_end.slice(0, -3)
                    : '00:00',
                }
              ); // 早出終了時間（昼）
              workTime[WORK_HOUR_ZONES.day.id] = _.assign(
                workTime[WORK_HOUR_ZONES.day.id],
                {
                  overtime_start: field.overtime_start
                    ? field.overtime_start.slice(0, -3)
                    : '00:00',
                }
              ); // 残業開始時間（昼）
              workTime[WORK_HOUR_ZONES.night.id] = _.assign(
                workTime[WORK_HOUR_ZONES.night.id],
                { start: field.work_start_time_night }
              ); // 労働開始時刻（夜）
              workTime[WORK_HOUR_ZONES.night.id] = _.assign(
                workTime[WORK_HOUR_ZONES.night.id],
                { end: field.work_end_time_night }
              ); // 労働終了時刻（夜）
              workTime[WORK_HOUR_ZONES.night.id] = _.assign(
                workTime[WORK_HOUR_ZONES.night.id],
                { working_time: workHour.worker_work_time }
              ); // 作業時間
              workTime[WORK_HOUR_ZONES.night.id] = _.assign(
                workTime[WORK_HOUR_ZONES.night.id],
                {
                  earlytime_end: field.earlytime_end_night
                    ? field.earlytime_end_night.slice(0, -3)
                    : '00:00',
                }
              ); // 早出終了時間（夜）
              workTime[WORK_HOUR_ZONES.night.id] = _.assign(
                workTime[WORK_HOUR_ZONES.night.id],
                {
                  overtime_start: field.overtime_start_night
                    ? field.overtime_start_night.slice(0, -3)
                    : '00:00',
                }
              ); // 残業開始時間（夜）
              workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
                workTime[WORK_HOUR_ZONES.midnight.id],
                { start: field.work_start_time_midnight }
              ); // 労働開始時刻（深夜）
              workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
                workTime[WORK_HOUR_ZONES.midnight.id],
                { end: field.work_end_time_midnight }
              ); // 労働終了時刻（深夜）
              workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
                workTime[WORK_HOUR_ZONES.midnight.id],
                { working_time: workHour.worker_work_time }
              ); // 作業時間
              workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
                workTime[WORK_HOUR_ZONES.midnight.id],
                {
                  earlytime_end: field.earlytime_end_midnight
                    ? field.earlytime_end_midnight.slice(0, -3)
                    : '00:00',
                }
              ); // 早出終了時間（深夜）
              workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
                workTime[WORK_HOUR_ZONES.midnight.id],
                {
                  overtime_start: field.overtime_start_midnight
                    ? field.overtime_start_midnight.slice(0, -3)
                    : '00:00',
                }
              ); // 残業開始時間（深夜）

              let workHourZone = SessionStorageService.getItem('work_hour_zone');
              let formValues = this.state.formValues;
              let fieldItem = this.state.fieldItem;
              fieldItem.oxygen_lack_print_flag = field.oxygen_lack_print_flag;
              formValues.work_early_times[0].earlytime_end =
                workTime[workHourZone].earlytime_end;
              formValues.work_over_times[0].overtime_start =
                workTime[workHourZone].overtime_start;

              this.setState({
                fieldItem,
                workTimes: field.work_hour,
                workTime,
                formValues,
                loaded: true,
              });
              this.checkRequired(formValues);
            }
          });
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.formValues.dayworker_type !==
      this.state.formValues.dayworker_type
    ) {
      // 人工種別が変更された時、各人工の人工種別を変更する
      this.updateDayworkerTypeInWorkDayworkers(
        this.state.formValues.dayworker_type
      );
    }

    if (this.state.isCopy) {
      this.setState({ isCopy: false });
    }
  }

  /**
   * @description 各人工の人工種別の更新
   * @param dayworkerType 人工種別
   */
  updateDayworkerTypeInWorkDayworkers = dayworkerType => {
    let formValues = { ...this.state.formValues };
    const updatedWorkDayworkers = _.map(
      formValues.work_dayworkers,
      workDayworker => ({
        ...workDayworker,
        dayworker_type: dayworkerType,
      })
    );
    formValues.work_dayworkers = updatedWorkDayworkers;
    this.setState({ formValues });
  };

  /**
   * 前回コピー
   */
  handleCopyDialog = () => {
    dialogLoader.show(LatestCopyDialog, this.LatestCopy);
  };

  /**
   * 連続登録
   */
  handleContinuityDialog = () => {
    dialogLoader.show(ContinuityDialog, {
      isWorkSchedule: this.props.isWorkSchedule,
    });
    this.submitRef.current.disabled = false;
    this.submitContinueRef.current.disabled = false;
  };

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 必須入力状況チェック (「必須項目の入力数」)
   * @param formValues {object} 入力値
   */
  checkRequired(formValues) {
    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const validate = _.cloneDeep(this.state.validate);
    let cnt = 0;
    const columns = this.state.isSpot
      ? requiredInput.hasSpot
      : requiredInput.columns;
    _.each(columns, column => {
      if (column === 'work_dayworkers') {
        if (
          formValues.work_dayworkers.filter(
            day_worker => day_worker.working_temp_person === ''
          ).length !== 0
        ) {
          return;
        }
      }
      if (
        (formValues[column] || formValues[column] === 0) &&
        !validate.messages[column]
      ) {
        cnt++;
      }
    });

    requiredInput.count = cnt;
    requiredInput.total = _.size(columns);
    this.setState({ requiredInput });
  }

  /**
   * 入力値の有効判定
   */
  validateValue(name = 'all', updateValues = {}) {
    let values = {};
    const validate = _.cloneDeep(this.state.validate);
    const formValues = _.cloneDeep(this.state.formValues);
    _.map(formValues, (value, index) => {
      if (_.isObject(value)) {
        values[index] = _.isNull(value) ? '' : value;
      } else {
        values[index] = _.isNull(value) ? '' : `${value}`;
      }
    });

    const schema = workRegisterFormSchema;
    const result = validateByJoi(schema, values);
    if (name !== 'all') {
      if (_.has(result.messages, name)) {
        // 指定したバリデートに対するエラーが result に入っている場合
        // validate の内容を更新する
        validate.messages[name] = result.messages[name];
      } else if (validate.messages[name]) {
        // 指定したバリデートに対するエラーが result に入っていない場合
        // validate の内容を削除する
        delete validate.messages[name];
      }
    } else if (result.messages) {
      validate.messages = result.messages;
    } else {
      validate.messages = {};
    }

    // 人工の入力欄複数に対して合計人工を求める
    let workersCount = 0;
    _.each(formValues.work_dayworkers, dayworker => {
      workersCount += parseInt(dayworker.working_temp_person);
    });
    const dayWorkerName =
      Number(values.dayworker_type) === WORKER_TYPES.contractor.id
        ? WORKER_TYPES.contractor.name
        : WORKER_TYPES.regular.name;

    if (['all', 'work_date_from', 'work_date_to'].includes(name)) {
      const later = moment(values.work_date_from).add(30, 'days');
      if (moment(values.work_date_to).isAfter(later)) {
        validate.messages.work_date_from = '30日以上は選択できません。';
      } else if (moment(values.work_date_from).isAfter(values.work_date_to)) {
        validate.messages.work_date_from =
          '開始日が終了日より後の日付になっています。';
      } else {
        delete validate.messages.work_date_from;
      }
    }

    if (['all', 'work_dayworkers', 'woman', 'non_japanese'].includes(name)) {
      if (['all', 'work_dayworkers'].includes(name)) {
        if (!_.has(result.messages, 'work_dayworkers')) {
          delete validate.messages.workers;
        } else {
          // result.messages.work_dayworkers オブジェクト内に
          // エラーメッセージが戻ってきているかどうかをチェックする
          let message_workers = '';
          // eslint-disable-next-line no-unused-vars
          for (let [key, value] of Object.entries(
            result.messages.work_dayworkers
          )) {
            message_workers = value;
          }
          validate.messages.workers = message_workers.working_temp_person;
          delete validate.messages.work_dayworkers;
        }
      }

      if (!_.isNaN(workersCount)) {
        if (Number(formValues.woman) > Number(workersCount)) {
          validate.messages.woman = messageUtility.getMessage(
            'E-001-301',
            dayWorkerName
          );
        } else {
          delete validate.messages.woman;
        }

        if (Number(formValues.non_japanese) > Number(workersCount)) {
          validate.messages.non_japanese = messageUtility.getMessage(
            'E-001-302',
            dayWorkerName
          );
        } else {
          delete validate.messages.non_japanese;
        }
      } else {
        delete validate.messages.woman;
        delete validate.messages.non_japanese;
      }
    }

    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    } else {
      validate.invalid = true;
    }

    this.setState({ validate }, () => {
      this.checkRequired(values);
    });
    return Object.keys(validate.messages).length;
  }

  /**
   * 日付選択
   */
  setDate = (name, date) => {
    // console.log('WorkRegister.jsx', 'setDate', name, date);
    if (name !== 'work_date_from' && name !== 'work_date_to') {
      throw new Error('WorkEdit.jsx setDropdownData');
    }

    const formValues = _.cloneDeep(this.state.formValues);
    if (formValues[name] !== date) {
      formValues[name] = date;
      this.setState({ formValues, workGroupDataUpdateFlag: true }, () => {
        this.validateValue(name);
        this.updateKeyPlan();
      });
      if (_.size(this.state.workTimes) === 1) {
        return;
      }
      let workTimes = _.cloneDeep(this.state.workTimes);
      let workHour = '';
      workTimes = _.sortBy(workTimes, 'start_date');
      if (
        moment(workTimes[workTimes.length - 1].start_date).isSameOrBefore(
          moment(formValues.work_date_from)
        )
      ) {
        workHour = workTimes[workTimes.length - 1];
      } else if (
        moment(formValues.work_date_to).isSameOrBefore(
          moment(workTimes[0].start_date)
        )
      ) {
        workHour = workTimes[0];
      } else {
        workHour = _.last(
          _.filter(workTimes, w =>
            moment(w.start_date).isSameOrBefore(formValues.work_date_from)
          )
        );
        if (!workHour) {
          workHour = _.head(
            _.filter(workTimes, w =>
              moment(w.start_date).isAfter(formValues.work_date_from)
            )
          );
        }
      }
      const workTime = _.cloneDeep(this.state.workTime);
      workTime[WORK_HOUR_ZONES.day.id].working_time = workHour.worker_work_time;
      workTime[WORK_HOUR_ZONES.night.id].working_time =
        workHour.worker_work_time;
      workTime[WORK_HOUR_ZONES.midnight.id].working_time =
        workHour.worker_work_time;
      this.setState({ workTime });
      if (this.state.isFifteen) {
        this.setState(prevState => {
          let formValues = _.cloneDeep(prevState.formValues);
          let workingTime =
            workTime[SessionStorageService.getItem('work_hour_zone')]
              .working_time;
          const minute = workingTime.slice(3, 5);
          if (minute === '00') {
            workingTime = `${workingTime.slice(0, 2)}.00`;
          } else if (minute === '15') {
            workingTime = `${workingTime.slice(0, 2)}.25`;
          } else if (minute === '30') {
            workingTime = `${workingTime.slice(0, 2)}.50`;
          } else if (minute === '45') {
            workingTime = `${workingTime.slice(0, 2)}.75`;
          }
          workingTime = Number(workingTime);
          _.each(formValues.work_dayworkers, workDayworker => {
            if (Number(workDayworker.working_temp_hour) > workingTime) {
              workDayworker.working_temp_hour = workingTime;
            }
            let cur = workDayworker.working_temp_hour / workingTime;
            let rlt = workDayworker.working_temp_person * cur;
            workDayworker.dayworker = rlt.toFixed(2);
          });

          return {
            formValues,
          };
        });
      }
    }
  };

  /**
   * フォーム入力
   */
  setFlatData = e => {
    const formValues = { ...this.state.formValues };
    formValues[e.target.name] = deleteControlCode(e.target.value);

    this.setState({ formValues });
  };

  /**
   * フォーム生成
   * @param data {object}  作業予定情報
   */
  initForm(data) {
    let formValues = { ...this.state.formValues };
    // データがある場合、formValuesのキーを元にしてdataをformValuesに投入する
    // これ以降のコードで二重代入を行なっているかもしれないが、このコードではコピーを優先し、後から投入された物を正とする
    if (!_.isEmpty(data)) {
      const formValuesFromData = _.reduce(
        _.keys(this.state.formValues),
        (formValuesData, key) => {
          if (_.has(data.work, key)) {
            return { ...formValuesData, [key]: data.work[key] };
          }
          return formValuesData;
        },
        {}
      );
      formValues = { ...formValues, ...formValuesFromData };
    }

    const work = data.work;
    const workGroup = data.work_group;
    // 既存dataの中にformValuesプロパティーが存在する場合、上書きする
    formValues.work_date_from = this.state.formValues.work_date_from;
    formValues.work_date_to = this.state.formValues.work_date_to;
    formValues.work_hour_zone = workGroup.work_hour_zone;
    formValues.field_tree_id = workGroup.field_tree_id;
    formValues.job_id = workGroup.job_id;
    formValues.foreman_user_id = workGroup.foreman_user_id;
    formValues.manager_user_id = work.manager_user_id;
    formValues.work_dayworkers = data.work_dayworkers;

    let workingTime = '';
    if (work.display_fifteen_minute_flg) {
      workingTime = this.state.workTime[
        SessionStorageService.getItem('work_hour_zone')
      ].working_time;
      const minute = workingTime.slice(3, 5);
      if (minute === '00') {
        workingTime = `${workingTime.slice(0, 2)}.00`;
      } else if (minute === '15') {
        workingTime = `${workingTime.slice(0, 2)}.25`;
      } else if (minute === '30') {
        workingTime = `${workingTime.slice(0, 2)}.50`;
      } else if (minute === '45') {
        workingTime = `${workingTime.slice(0, 2)}.75`;
      }
      workingTime = stringToNumber(workingTime);
      _.each(formValues.work_dayworkers, workDayworker => {
        if (Number(workDayworker.working_temp_hour) > workingTime) {
          workDayworker.working_temp_hour = workingTime;
        }
        let cur = workDayworker.working_temp_hour / workingTime;
        let rlt = workDayworker.working_temp_person * cur;
        workDayworker.dayworker = rlt.toFixed(2);
      });
    } else {
      workingTime = '1.00';
    }

    if (formValues.work_dayworkers.length === 0) {
      const workDayworker = {
        dayworker_type: this.state.formValues.dayworker_type,
        working_temp_person: '',
        working_temp_hour: workingTime,
        dayworker: '',
      };
      formValues.work_dayworkers.push(workDayworker);
    }

    if (_.isEmpty(data.work_early_times)) {
      let workHourZone = SessionStorageService.getItem('work_hour_zone');
      const earlyWorkStart = '';
      const overWorkEnd = this.state.workTime[workHourZone].earlytime_end;
      const earlyOverTime = {
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: earlyWorkStart,
        earlytime_end: overWorkEnd,
      };
      formValues.work_early_times = [earlyOverTime];
    } else {
      let workEarlyTimes = [];
      _.each(data.work_early_times, work_early_time => {
        let early = {
          id: work_early_time.id,
          working_temp_person: work_early_time.working_temp_person,
          working_temp_hour: work_early_time.working_temp_hour,
          overtime_start: this.getOvertimeStart(
            work_early_time.earlytime_end,
            work_early_time.working_temp_hour
          ),
          earlytime_end: work_early_time.earlytime_end.slice(0, -3),
        };
        workEarlyTimes.push(early);
      });
      formValues.work_early_times = workEarlyTimes;
    }

    if (_.isEmpty(data.work_over_times)) {
      let workHourZone = SessionStorageService.getItem('work_hour_zone');
      const earlyWorkStart = this.state.workTime[workHourZone].overtime_start;
      const overWorkEnd = '';
      const earlyOverTime = {
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: earlyWorkStart,
        earlytime_end: overWorkEnd,
      };
      formValues.work_over_times = [earlyOverTime];
    } else {
      let workOverTimes = [];
      _.each(data.work_over_times, work_over_time => {
        let over = {
          id: work_over_time.id,
          working_temp_person: work_over_time.working_temp_person,
          working_temp_hour: work_over_time.working_temp_hour,
          overtime_start: work_over_time.overtime_start.slice(0, -3),
          earlytime_end: this.getEarlytimeEnd(
            work_over_time.overtime_start,
            work_over_time.working_temp_hour
          ),
        };
        workOverTimes.push(over);
      });
      formValues.work_over_times = workOverTimes;
    }
    formValues.schedule_flag = this.props.isWorkSchedule
      ? SCHEDULE_STATUS.schedule.id
      : SCHEDULE_STATUS.result.id; // 予定フラグ

    // キープランがあれば設定、なければ後続のupdateKeyPlanで設定される。
    if (!_.isNull(data.work_key_plan_image)) {
      formValues.work_key_plan_image = data.work_key_plan_image;
      const image = { ...this.state.image };
      image.path = data.work_key_plan_image.img_url;
      image.json = data.work_key_plan_image.layout_json;
      image.keyplanId = data.work_key_plan_image.id;
      this.setState({ image, isKeyPlanChanged: true });
    }

    // プルダウン項目_取得値代入処理
    const pulldownName = {};
    const mergeWork = { ...work, ...workGroup };
    _.each(_.keys(this.state.pulldownName), key => {
      if (key === 'manager_user_name') {
        if (
          mergeWork[`${key}_sei`] !== '' &&
          !_.isNull(mergeWork[`${key}_sei`])
        ) {
          pulldownName[key] = `${mergeWork[`${key}_sei`]} ${
            mergeWork[`${key}_mei`]
          }`;
        }
      } else {
        if (mergeWork[key] !== '' && !_.isNull(mergeWork[key])) {
          pulldownName[key] = mergeWork[key];
        }
      }
    });
    pulldownName.company_name = getDisplayedCompanyName(workGroup)

    if (this.state.isShowSptDropdown && formValues.foreman_user_id) {
      this.autoSelectSptWorkAndPlace(formValues.foreman_user_id);
    }

    this.checkRequired(formValues);
    this.setState(
      {
        formValues,
        pulldownName,
        isCopy: true,
        isFifteen: work.display_fifteen_minute_flg,
      },
      () => {
        // 前回コピーで取得したデータにキープランがなければ現在のキープランを表示
        if (_.isNull(data.work_key_plan_image)) {
          this.updateKeyPlan();
        }
        this.validateValue();
      }
    );
  }

  /**
   * 早出開始時間を計算
   * @param earlytimeEnd {string}
   * @param tempHour {string}
   */
  getOvertimeStart(earlytimeEnd, tempHour) {
    let start = new Date(`2016/01/01 ${earlytimeEnd}`);
    var hour = parseFloat(tempHour);
    let end = new Date(start.getTime() - hour * 60 * 60 * 1000);
    let result = `${`000${end.getHours()}`.slice(
      -2
    )}:${`00${end.getMinutes()}`.substr(
      `00${end.getMinutes()}`.length - 2,
      2
    )}`;
    return result;
  }

  /**
   * 残業終了時間を計算
   * @param overtimeStart {string}
   * @param tempHour {string}
   */
  getEarlytimeEnd(overtimeStart, tempHour) {
    let start = new Date(`2016/01/01 ${overtimeStart}`);
    var hour = parseFloat(tempHour);
    let end = new Date(start.getTime() + hour * 60 * 60 * 1000);
    let result = `${`000${end.getHours()}`.slice(
      -2
    )}:${`00${end.getMinutes()}`.substr(
      `00${end.getMinutes()}`.length - 2,
      2
    )}`;
    return result;
  }

  /**
   * ドロップダウン選択
   * @param name {string}
   * @param value {int}
   */
  setDropdownData = (name, value) => {
    // console.log('WorkRegister.jsx', 'setDropdownData', name, value);
    if (
      name === 'field_tree_id' ||
      name === 'job_id' ||
      name === 'foreman_user_id'
    ) {
      this.setState({ workGroupDataUpdateFlag: true });
    }

    this.setState(
      prevState => {
        let formValues = _.cloneDeep(prevState.formValues);
        formValues[name] = _.defaultTo(deleteControlCode(value), '');

        // 作業予定/作業実績 の編集画面で
        // 協力会社Dropdownが動作した時に
        // 職種Dropdown 職長Dropdown の初期化が行われる
        // 処理は次の場所で行われている
        //  FieldTreeJob.jsx componentWillReceiveProps
        //  FieldTreeUser.jsx componentWillReceiveProps
        // 不具合[BLDE_V2-17211]として、内部値が更新されていない問題があり
        // この箇所で内部値をクリアしておく

        // 協力会社:field_tree_id
        // 職種:job_id
        // 職長:foreman_user_id

        if (
          name === 'field_tree_id' &&
          this.state.formValues.field_tree_id !== value
        ) {
          // 協力会社に変更があった場合は、職種|職長の値は初期化される
          formValues.job_id = null;
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        } else if (
          name === 'job_id' &&
          this.state.formValues.job_id !== value
        ) {
          // 職種に変更があった場合は、職長の値は初期化される
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        } else if (
          name === 'foreman_user_id' &&
          this.state.formValues.foreman_user_id !== value
        ) {
          formValues.main_work_type_id = null;
          formValues.sub_work_type_id = null;
        }
        return {
          formValues,
        };
      },
      () => {
        this.validateValue(name);
        if (
          name === 'field_tree_id' ||
          name === 'job_id' ||
          name === 'foreman_user_id'
        ) {
          this.updateKeyPlan();
        }
        if (name === 'foreman_user_id') {
          const foreman_user_id = this.state.formValues.foreman_user_id;
          if (foreman_user_id && this.state.isShowSptDropdown) {
            this.autoSelectSptWorkAndPlace(foreman_user_id);
          }
        }
      }
    );
  };

  autoSelectSptWorkAndPlace = (foreman_user_id) => {
    WorkScheduleService.getHistorySpt(this.state.fieldId, {
      foreman_user_id,
    }).then(response => {
      const history = _.get(response, 'data.entities.work');
      if (!_.isEmpty(history)) {
        const formValues = _.cloneDeep(this.state.formValues);
        const pulldownName = _.cloneDeep(this.state.pulldownName);
        formValues.spt_field_work_type_id = _.toString(
          history.spt_field_work_type_id
        );
        pulldownName.spt_main_sub_progress_quanlity_name =
          history.spt_main_sub_progress_quanlity_name;
        _.forEach(
          FIELD_ITEM_LISTS,
          ({ propName, labelName, displayFlagName }) => {
            if (this.state.fieldItem[displayFlagName]) {
              formValues[propName] = history[propName];
              pulldownName[labelName] = history[labelName];
            }
          }
        );
        this.setState({ formValues, pulldownName });
      }
    });
  }

  /**
   * キープラン選択
   *  この関数は
   *    キープランプルダウンで項目を選択した時
   *  に呼び出されます
   *    未選択状態にした時
   *  には呼び出されません。(deleteKeyPlanが呼び出される)
   */
  setDropdownKeyplanData = value => {
    const image = _.cloneDeep(this.state.image);
    const formValues = _.cloneDeep(this.state.formValues);
    image.path = value.image_url;
    image.json = undefined;
    formValues.work_key_plan_image.key_plan_category_code = value.category_code;
    formValues.work_key_plan_image.edited_image = '';
    formValues.work_key_plan_image.layout_json = undefined;
    this.setState({
      image,
      formValues,
      isKeyPlanChanged: true,
    });
  };

  /**
   * キープラン削除
   *  この関数は、
   *    キープランプルダウンを未選択にする時と
   *    キープラン画像表示時に[x]ボタンをクリックする時
   *  に呼び出されます
   */
  deleteKeyPlan = () => {
    let image = this.state.image;
    let formValues = this.state.formValues;
    image.path = '';
    image.json = '';
    image.keyplanId = '';
    image.edited = false;
    formValues.work_key_plan_image = {
      key_plan_category_code: '',
      edited_image: '',
    };
    this.setState({
      image,
      formValues,
      isKeyPlanChanged: true,
    });
  };

  /**
   * キープラン編集フラグ
   */
  setEditKeyplanFlag = () => {
    let image = this.state.image;
    image.edited = true;
    this.setState({ image, isKeyPlanChanged: true });
  };

  /**
   * 人工
   * 15分単位で計算
   */
  set15Time = () => {
    const isFifteen = !this.state.isFifteen;
    let workingTime = '';
    if (isFifteen) {
      workingTime = this.state.workTime[
        SessionStorageService.getItem('work_hour_zone')
      ].working_time;
      const minute = workingTime.slice(3, 5);
      if (minute === '00') {
        workingTime = `${workingTime.slice(0, 2)}.00`;
      } else if (minute === '15') {
        workingTime = `${workingTime.slice(0, 2)}.25`;
      } else if (minute === '30') {
        workingTime = `${workingTime.slice(0, 2)}.50`;
      } else if (minute === '45') {
        workingTime = `${workingTime.slice(0, 2)}.75`;
      }
      workingTime = Number(workingTime);
    } else {
      workingTime = '1.00';
    }
    let formValues = this.state.formValues;
    _.each(formValues.work_dayworkers, worker => {
      worker.working_temp_hour = workingTime;
      worker.dayworker =
        !!worker.working_temp_person &&
        Number(worker.working_temp_person).toFixed(2);
    });
    this.setState(
      {
        isFifteen,
        formValues: {
          ...formValues,
          display_fifteen_minute_flg: !formValues.display_fifteen_minute_flg,
        },
      },
      () => {
        this.validateValue('work_dayworkers');
      }
    );
  };

  /**
   * 人工セット
   */
  setWorkDayTime = (e, key) => {
    let formValues = this.state.formValues;
    let workDayworker = formValues.work_dayworkers[key];
    workDayworker[e.target.name] = e.target.value;
    if (workDayworker.working_temp_person === '') {
      workDayworker.dayworker = '';
    } else {
      if (this.state.isFifteen) {
        let workingTime = this.state.workTime[
          SessionStorageService.getItem('work_hour_zone')
        ].working_time;
        workingTime = moment.duration(workingTime).asHours();
        let cur = workDayworker.working_temp_hour / workingTime;
        let rlt = workDayworker.working_temp_person * cur;
        workDayworker.dayworker = rlt.toFixed(2);
      } else {
        let rst =
          workDayworker.working_temp_person * workDayworker.working_temp_hour;
        workDayworker.dayworker = rst.toFixed(2);
      }
    }
    formValues.work_dayworkers[key] = workDayworker;
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 人工追加
   */
  addWorkDayTime = () => {
    let formValues = this.state.formValues;
    let workingTime = '';
    if (this.state.isFifteen) {
      workingTime = this.state.workTime[
        SessionStorageService.getItem('work_hour_zone')
      ].working_time;
      const minute = workingTime.slice(3, 5);
      if (minute === '00') {
        workingTime = `${workingTime.slice(0, 2)}.00`;
      } else if (minute === '15') {
        workingTime = `${workingTime.slice(0, 2)}.25`;
      } else if (minute === '30') {
        workingTime = `${workingTime.slice(0, 2)}.50`;
      } else if (minute === '45') {
        workingTime = `${workingTime.slice(0, 2)}.75`;
      }
      workingTime = Number(workingTime);
    } else {
      workingTime = '1.00';
    }
    const workDayworker = {
      dayworker_type: this.state.formValues.dayworker_type,
      working_temp_person: '',
      working_temp_hour: workingTime,
      dayworker: '',
    };
    formValues.work_dayworkers.push(workDayworker);
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 人工削除
   */
  removeWorkDayTime = key => {
    let formValues = this.state.formValues;
    let workDayworkers = [];
    _.each(formValues.work_dayworkers, (work_dayworker, index) => {
      if (index !== key) {
        workDayworkers.push(work_dayworker);
      }
    });
    formValues.work_dayworkers = workDayworkers;
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 残業早出入力
   * @param key {string}
   * @param name {string}
   * @param flag {int} // 早出残業フラグ
   */
  setEarlyOverTime = (e, key, name, flag) => {
    let workHourZone = SessionStorageService.getItem('work_hour_zone');
    let formValues = this.state.formValues;
    let workEarlyOverTime = formValues[name][key];
    workEarlyOverTime[e.target.name] = e.target.value;
    if (flag === WORK_EARLY_OVER_TYPES.early.id) {
      workEarlyOverTime.overtime_start = this.getOvertimeStart(
        this.state.workTime[workHourZone].earlytime_end,
        workEarlyOverTime.working_temp_hour
      );
    } else if (WORK_EARLY_OVER_TYPES.over.id) {
      workEarlyOverTime.earlytime_end = this.getEarlytimeEnd(
        this.state.workTime[workHourZone].overtime_start,
        workEarlyOverTime.working_temp_hour
      );
    }
    formValues[name][key] = workEarlyOverTime;
    this.setState({ formValues });
  };

  /**
   * 早出残業追加
   * @param name {string}
   */
  addEarlyOverTime = name => {
    let formValues = this.state.formValues;
    let workHourZone = SessionStorageService.getItem('work_hour_zone');
    const earlyWorkStart =
      name === 'work_over_times'
        ? this.state.workTime[workHourZone].overtime_start
        : '';
    const overWorkEnd =
      name === 'work_early_times'
        ? this.state.workTime[workHourZone].earlytime_end
        : '';
    const earlyOverTime = {
      fixed_unfixed_type: WORKER_TYPES.contractor.id,
      working_temp_person: SYSTEM_WORKER_COUNT[0].id,
      working_temp_hour: 0.0,
      overtime_start: earlyWorkStart,
      earlytime_end: overWorkEnd,
    };
    formValues[name].push(earlyOverTime);
    this.setState({ formValues });
  };

  /**
   * 早出残業削除
   * @param key {string} index
   * @param name {string}
   */
  removeEarlyOverTime = (key, name) => {
    let formValues = this.state.formValues;
    let workEarlyOverTimes = [];
    _.each(formValues[name], (workEarlyOverTime, index) => {
      if (index !== key) {
        workEarlyOverTimes.push(workEarlyOverTime);
      }
    });
    formValues[name] = workEarlyOverTimes;
    this.setState({ formValues });
  };

  /**
   * 前回コピー
   */
  getLatestSchedule() {
    const date = this.state.formValues.work_date_from;
    const workHourZone = SessionStorageService.getItem('work_hour_zone');
    WorkScheduleService.latestSchedule(this.state.fieldId, {
      schedule_flag: this.props.isWorkSchedule
        ? SCHEDULE_STATUS.schedule.id
        : SCHEDULE_STATUS.result.id,
      date,
      work_hour_zone: workHourZone,
    }).then(response => {
      if (response.result) {
        if (_.isEmpty(response.data.entities)) {
          alert('前回データが存在しません。');
        } else {
          this.initForm(response.data.entities);
        }
      }
    });
  }

  /**
   * 登録
   * continuityがtrueであれば「続けて登録」
   * @param continuity {bool}
   */
  eventSubmit = (continuity = false) => {
    this.submitRef.current.disabled = true;
    this.submitContinueRef.current.disabled = true;
    const listMessageConcurrentException = [
      '（大工種）が必須です。',
      '場所が必須です。',
    ];

    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          display_fifteen_minute_flg: this.state.isFifteen,
        },
        apiErrorMessage: '',
      },
      () => {
        let validate = this.validateValue();
        if (validate !== 0) {
          this.submitRef.current.disabled = false;
          this.submitContinueRef.current.disabled = false;
          return;
        }

        let param = _.cloneDeep(this.state.formValues);
        // console.log('WorkRegister.jsx eventSubmit 1', param.work_key_plan_image.layout_json);
        console.log('WorkRegister.jsx eventSubmit 1');

        /**
         * is_not_update: true 作業グループのキープラン更新しない
         * is_not_update: false 作業グループのキープラン更新する
         */
        if (_.has(param, 'work_key_plan_image.layout_json.objects')) {
          console.log(
            'WorkRegister.jsx eventSubmit 1-1 キープラン選択 編集',
            param.work_key_plan_image
          );
          param.work_key_plan_image.is_not_update = false;
        } else if (
          param.work_key_plan_image.key_plan_category_code === '' ||
          _.isUndefined(param.work_key_plan_image.key_plan_category_code)
        ) {
          console.log('WorkRegister.jsx eventSubmit 1-2 キープラン未選択');

          /**
           * 作業グループが決定された時、紐付くキープランがあればセットされている
           * 紐付くキープランあり + カテゴリーコードなし => キープランなしに更新する
           * 紐付くキープランなし + カテゴリーコードなし => キープランなしなので更新しない
           */
          if (this.state.isSetExistingWorkGroupKeyPlan) {
            param.work_key_plan_image.is_not_update = false;
          } else {
            param.work_key_plan_image.is_not_update = true;
          }
          param.work_key_plan_image.layout_json = null;
          param.work_key_plan_image.edited_image = null;
        } else if (_.isUndefined(param.work_key_plan_image.layout_json)) {
          console.log('WorkRegister.jsx eventSubmit 1-3 キープラン選択 切替');
          // キープランを選択して編集していない場合
          // 編集したデータが残っている場合があるので、
          // 下記のパラメータはクリアする
          param.work_key_plan_image.is_not_update = false;
          param.work_key_plan_image.layout_json = null;
          param.work_key_plan_image.edited_image = null;
        } else {
          console.log(
            'WorkRegister.jsx eventSubmit 1-4 キープラン選択 未切替 未編集 前回からのコピー　既存キープランあり'
          );
          // 2020/04/09(Thu) @sa-yamamoto
          // 作業予定新規画面では
          //    作業予定編集画面のような
          //    また、人工ダイアログから呼び出された場合
          // というのが存在しないのだが
          // 前回コピーの場合のみこの分岐に入る

          /**
           * ユーザーがキープランを選択、編集、削除操作している場合のみ更新
           */
          if (this.state.isKeyPlanChanged) {
            param.work_key_plan_image.is_not_update = false;
          } else {
            param.work_key_plan_image.is_not_update = true;
          }

          // 前回コピーの際は、layout_json の値が文字列で
          // そのままだと誤動作するのでオブジェクトに変更する。
          if (_.isString(param.work_key_plan_image.layout_json)) {
            param.work_key_plan_image.layout_json = JSON.parse(
              param.work_key_plan_image.layout_json
            );
          }
        }
        console.log(
          'WorkRegister.jsx eventSubmit 2',
          param.work_key_plan_image.layout_json
        );
        if (!_.isBoolean(param.work_key_plan_image.is_not_update)) {
          throw new Error('WorkRegister.jsx eventSubmit is_not_update unset');
        }

        if (!this.state.isShowMainSubDropdown) {
          param.main_work_type_id = null;
          param.sub_work_type_id = null;
        }

        if (!this.state.formValues.isSubTypeRequired) {
          param.sub_work_type_id = null;
        }

        if (!this.state.isShowSptDropdown) {
          param.spt_field_work_type_id = null;
        }

        param = this.checkEarlyOverTimes(param);
        WorkScheduleService.create(this.state.fieldId, param).then(response => {
          console.log('WorkRegister.jsx response', response);

          // API の戻り値について
          //  正常系：response.result === true
          //  異常系：response.data.result === false
          // エラー時は response.status が 400 等になる。
          // request.js で error オブジェクトを返しているため。
          // 正常時は status が 0 になる。

          if (response.status === 422) {
            if (response.data.message.includes('バリデーションエラー')) {
              this.submitRef.current.disabled = false;
              this.submitContinueRef.current.disabled = false;
              this.setState({
                apiErrorMessage: '同一のデータが既に登録済みです。',
              });
            }
            return;
          }
          if (response.status === 400) {
            this.submitRef.current.disabled = false;
            this.submitContinueRef.current.disabled = false;

            if (response.data.message.includes('人工は必須')) {
              this.showErrorDialog(response.data.message);
              let validate = { ...this.state.validate };
              validate.messages.work_date_from = response.data.message;
              validate.invalid = true;
              this.setState({ validate });
              return;
            } else if (
              _.includes(listMessageConcurrentException, response.data.message)
            ) {
              this.setState({
                isShowPopupError: true,
              });
            } else if (!response.data.result) {
              if (
                isPrimeContractorHasBlockedOrFinishedWorkError(
                  response.data.message
                )
              ) {
                return dialogLoader.show(FormInformationDialog, {
                  title: messageUtility.getMessage('E-001-422'),
                  message: messageUtility.getMessage('E-001-423'),
                  onClose: () => {
                    window.location.reload();
                  },
                });
              } else if (
                response.data.message === messageUtility.getMessage('E-000-073')
              ) {
                return dialogLoader.show(CancelAndConfirmDialog, {
                  title: messageUtility.getMessage('E-001-402'),
                  message: response.data.message,
                  confirmButtonText: messageUtility.getMessage('I-000-180'),
                  cancelButtonText: messageUtility.getMessage('I-000-017'),
                  effectiveButtonClassName: 'btn',
                  onCancel: () => {
                    dialogLoader.close();
                  },
                  onConfirm: () => {
                    window.location.reload();
                  },
                });
              }
              return this.showErrorDialog(response.data.message);
            }
          }

          if (response.result === true) {
            if (continuity) {
              // 続けて登録
              this.events.dialog.showContinuity();
            } else {
              // 一覧画面へ
              EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
              _slideLoader.close(this.props.vw);
            }
          }
        });
      }
    );
  };

  /**
   * 早出残業入力チェック
   * 0の場合POSTしない
   */
  checkEarlyOverTimes(formValues) {
    let early = formValues.work_early_times;
    let over = formValues.work_over_times;
    let earlyTimes = [];
    _.each(early, time => {
      if (time.working_temp_hour > 0 && time.working_temp_person > 0) {
        earlyTimes.push(time);
      }
    });
    let overTimes = [];
    _.each(over, time => {
      if (time.working_temp_hour > 0 && time.working_temp_person > 0) {
        overTimes.push(time);
      }
    });
    formValues.work_early_times = earlyTimes;
    formValues.work_over_times = overTimes;
    return formValues;
  }

  keyplanObserver() {
    // console.log('WorkRegister.jsx', 'keyplanObserver');
    const formValues = _.cloneDeep(this.state.formValues);
    const key_plan = { ...this.state.formValues.work_key_plan_image };
    key_plan.edited_image = document.getElementById('keyplan-image-val').value;
    key_plan.layout_json = JSON.parse(
      document.getElementById('keyplan-image-obj').value
    );
    formValues.work_key_plan_image = key_plan;
    // console.log('WorkEdit.jsx', 'keyplanObserver',
    //   document.getElementById('keyplan-image-val').value,
    //   document.getElementById('keyplan-image').src,
    //   key_plan.layout_json,
    // );

    const image = _.cloneDeep(this.state.image);
    image.path = key_plan.edited_image;
    image.json = key_plan.layout_json;
    this.setState({ formValues, image });
  }
  /* eslint-enable prettier/prettier */

  // getKeyPlanDataByCategoryCodeで使用のため
  setLoadedKeyPlanData(keyPlanData) {
    this.setState({
      loadedKeyPlanData: keyPlanData,
    });
  }

  checkClearValidate = () => {
    const keyMessagesPlace = KEY_MESSAGES_REQUIRE_INPUT_PLACE;
    let messages = _.cloneDeep(this.state.validate.messages);
    const newKeyMessages = _.filter(Object.keys(messages), item => {
      return _.includes(keyMessagesPlace, item);
    });

    if (_.isEmpty(newKeyMessages)) {
      return;
    }
    _.forEach(newKeyMessages, key => {
      delete messages[key];
    });

    this.setState({
      validate: {
        invalid: !_.isEmpty(messages),
        messages,
        validated: !_.isEmpty(messages),
      },
    });
  };

  setVisibleMainSubWorkDropdown = (
    dateUpdate,
    work_date_from,
    work_date_to
  ) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const progressDateFrom = moment(this.state.progress_date_from);
    const progressDateTo = moment(this.state.progress_date_to);
    const workDateFrom = moment(work_date_from);
    const workDateTo = moment(work_date_to);
    const lengthListMain = this.state.lengthOfListMainWorkTypes;

    if (dateUpdate === UPDATE_DATE.work_date_from) {
      formValues.work_date_from = work_date_from;
    } else if (dateUpdate === UPDATE_DATE.work_date_to) {
      formValues.work_date_to = work_date_to;
    }

    if (
      lengthListMain === 0 ||
      !progressDateFrom.isValid() ||
      (!progressDateTo.isValid() && progressDateFrom.isAfter(workDateTo)) ||
      workDateTo.isBefore(progressDateFrom) ||
      progressDateTo.isBefore(workDateFrom)
    ) {
      formValues.isMainTypeRequired = false;
      formValues.isSubTypeRequired = false;
      formValues.workPlaceRequireType = null;
      const requireColumns = KEY_MESSAGES_REQUIRE_INPUT_PLACE;
      const columnRequire = _.filter(requiredInput.columns, item => {
        return !_.includes(requireColumns, item);
      });

      if (this.state.isShowMainSubDropdown) {
        this.setState(
          {
            formValues,
            requiredInput: {
              ...this.state.requiredInput,
              columns: columnRequire,
            },
            isShowMainSubDropdown: false,
          },
          () => {
            this.checkClearValidate();
            this.checkRequired(this.state.formValues);
          }
        );
      }
    } else {
      const temporaryWorkPlace = this.temporaryWorkPlaceRequireType;
      if (!this.state.isShowMainSubDropdown) {
        if (this.state.listSubWorkTypes.length > 0) {
          requiredInput.columns.push('sub_work_type_id');
          formValues.isSubTypeRequired = true;
        }
        requiredInput.columns.push('main_work_type_id');
        const workRequire = this.setNewWorkPlaceRequireInput(
          temporaryWorkPlace
        );
        _.forEach(workRequire, value => {
          requiredInput.columns.push(value);
        });
        formValues.isMainTypeRequired = true;
        formValues.workPlaceRequireType = temporaryWorkPlace;
        this.setState(
          {
            formValues,
            requiredInput,
            isShowMainSubDropdown: true,
          },
          () => {
            this.checkRequired(this.state.formValues);
          }
        );
      }
    }
  };

  getSptLinkageSetting = () => {
    SptService.getSptLinkageSetting(this.state.fieldId).then(response => {
      const sptLinkageSetting = _.get(response, 'data.entities.spt_linkage_setting') || {};
      this.setState({
        sptDateFrom: sptLinkageSetting.linkage_start_date || null,
        sptDateTo: sptLinkageSetting.linkage_end_date || null,
      }, this.setVisibleSptDropdown);
    });
  }

  setVisibleSptDropdown = (work_date_from = this.state.formValues.work_date_from, work_date_to = this.state.formValues.work_date_to) => {
    const sptDateFrom = moment(this.state.sptDateFrom);
    if (!sptDateFrom.isValid()) {
      return;
    }
    const prevShowSptDropdown = this.state.isShowSptDropdown;
    const sptDateTo = moment(this.state.sptDateTo);
    const workDateFrom = moment(work_date_from);
    const workDateTo = moment(work_date_to);
    const isHidden =
      sptDateFrom.isAfter(workDateTo) || sptDateTo.isBefore(workDateFrom);
    this.setState(
      {
        isShowSptDropdown: !isHidden,
      },
      () => {
        const foreman_user_id = this.state.formValues.foreman_user_id;
        if (
          !prevShowSptDropdown &&
          this.state.isShowSptDropdown &&
          foreman_user_id
        ) {
          this.autoSelectSptWorkAndPlace(foreman_user_id);
        }
      }
    );
  };

  setWorkDateFrom = date => {
    this.setVisibleMainSubWorkDropdown(
      UPDATE_DATE.work_date_from,
      date,
      this.state.formValues.work_date_to
    );
    this.setVisibleSptDropdown(date);
  };

  setWorkDateTo = date => {
    this.setVisibleMainSubWorkDropdown(
      UPDATE_DATE.work_date_to,
      this.state.formValues.work_date_from,
      date
    );
    this.setVisibleSptDropdown(undefined, date);
  };

  setValidateSubWorkAndPlaces = () => {
    this.setState(
      prevState => {
        const requiredInput = _.cloneDeep(prevState.requiredInput);
        const requireItem = _.cloneDeep(this.temporaryWorkPlaceRequireType);
        requiredInput.columns = _.filter(
          requiredInput.columns,
          item => !_.includes(CONST_ABCD__PLACE_AND_SUB_WORK, item)
        );
        let isSubTypeRequired = false;
        const workRequirePlace = this.setNewWorkPlaceRequireInput(requireItem);
        _.forEach(workRequirePlace, value => {
          requiredInput.columns.push(value);
        });
        if (!_.isEmpty(this.state.listSubWorkTypes)) {
          if (!_.includes(requiredInput.columns, 'sub_work_type_id')) {
            requiredInput.columns.push('sub_work_type_id');
          }
          isSubTypeRequired = true;
        }
        return {
          formValues: {
            ...this.state.formValues,
            isSubTypeRequired,
            workPlaceRequireType: requireItem,
          },
          requiredInput,
        };
      },
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  setNewWorkPlaceRequireInput = newWorkPlaceRequireInput => {
    let listRequireWorkPlace = [];
    _.forEach(newWorkPlaceRequireInput, key => {
      switch (key) {
        case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[0]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[1]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[2]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[3]);
          break;
        default:
          break;
      }
    });
    return listRequireWorkPlace;
  };

  setValueMainWorkTypes = (
    id,
    name = null,
    requirePlace = null,
    isResetSub = true
  ) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const selectedMainWork = _.find(
      this.state.listMainWorkTypes,
      item => item.main_work_type_id === parseInt(id)
    );
    let requireItem = requirePlace;
    formValues.main_work_type_name = name;
    if (selectedMainWork) {
      requireItem = selectedMainWork.required_item_list_ids;
      formValues.main_work_type_name = selectedMainWork.name;
    }
    formValues.main_work_type_id = !_.isNull(id) ? parseInt(id) : null;
    if (isResetSub === true) {
      formValues.sub_work_type_id = null;
      formValues.sub_work_type_name = null;
    }
    this.temporaryWorkPlaceRequireType = requireItem;
    this.setState({
      formValues,
      keySubWork: this.state.keySubWork + 1,
      keyMainWork: this.state.keyMainWork + 1,
      listSubWorkTypes: [],
    });
  };

  setValueSubWorkTypes = (
    id,
    name = null,
    requirePlace = null,
    isResetRequired = false
  ) => {
    let workPlaceRequireType;
    let sub_work_type_name;
    const selectedSubWork = _.find(
      this.state.listSubWorkTypes,
      item => item.sub_work_type_id === parseInt(id)
    );
    const requiredInput = _.cloneDeep(this.state.requiredInput);

    if (selectedSubWork) {
      const columns = _.filter(
        requiredInput.columns,
        item => !_.includes(REQUIRE_WORK_PLACE, item)
      );
      requiredInput.columns = columns;
      if (selectedSubWork.required_item_list_ids) {
        const newColumnRequireInput = this.setNewWorkPlaceRequireInput(
          selectedSubWork.required_item_list_ids
        );
        _.forEach(newColumnRequireInput, value => {
          requiredInput.columns.push(value);
        });
        workPlaceRequireType = selectedSubWork.required_item_list_ids;
      } else {
        workPlaceRequireType = null;
      }
      sub_work_type_name = selectedSubWork.name;
    } else {
      sub_work_type_name = name;
      if (!isResetRequired) {
        workPlaceRequireType = requirePlace;
      }
    }
    if (!_.isUndefined(workPlaceRequireType)) {
      this.temporaryWorkPlaceRequireType = workPlaceRequireType;
    }

    this.setState(
      prev => ({
        formValues: {
          ...prev.formValues,
          workPlaceRequireType: _.isUndefined(workPlaceRequireType)
            ? prev.formValues.workPlaceRequireType
            : workPlaceRequireType,
          sub_work_type_name: _.isUndefined(sub_work_type_name)
            ? prev.formValues.sub_work_type_name
            : sub_work_type_name,
          sub_work_type_id: !_.isNull(id) ? parseInt(id) : null,
        },
        requiredInput,
        keySubWork: this.state.keySubWork + 1,
      }),
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  getListMainWorkTypesData = response => {
    const totalData = _.get(response, 'data.total') || 0;
    const newMainWorkData =
      _.get(response, 'data.entities.field_main_work_types') || [];
    this.setState({
      listMainWorkTypes: [...this.state.listMainWorkTypes, ...newMainWorkData],
      lengthOfListMainWorkTypes: totalData,
    });
  };

  getListSubWorkTypesData = response => {
    const newSubWorkData =
      _.get(response, 'data.entities.field_sub_work_types') || [];
    this.setState(
      {
        listSubWorkTypes: [...this.state.listSubWorkTypes, ...newSubWorkData],
      },
      () => {
        this.setValidateSubWorkAndPlaces();
      }
    );
  };

  setListHistoriesMainWork = listHistoriesMain => {
    this.listHistoriesMain = listHistoriesMain;
  };

  setListHistoriesSubWork = listHistoriesSub => {
    this.listHistoriesSub = listHistoriesSub;
  };

  setFirstTimeGetHistories = isFirstTime => {
    this.isFirstTimeGetHistories = isFirstTime;
  };

  removeRequireSubAndWorkPlace = () => {
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    requiredInput.columns = _.filter(
      requiredInput.columns,
      item => !_.includes(CONST_ABCD__PLACE_AND_SUB_WORK, item)
    );
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          workPlaceRequireType: null,
          isSubTypeRequired: false,
        },
        requiredInput,
        listSubWorkTypes: [],
      },
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  // loadedKeyPlanDataに該当データがあればそれを返し、なければAPIから検索する
  async getKeyPlanDataByCategoryCode(categoryCode) {
    const searchFromLoadedKeyPlanData = this.state.loadedKeyPlanData.find(
      item => item.category_code === categoryCode
    );
    if (searchFromLoadedKeyPlanData) {
      return searchFromLoadedKeyPlanData;
    }
    const searchParams = {
      field_id: this.state.fieldId,
      limit: 100,
      category_code: categoryCode,
    };
    const keyPlanByCategoryCodeResponse = await FieldImageService.keyplan(
      this.state.fieldId,
      searchParams
    );
    if (keyPlanByCategoryCodeResponse.result) {
      const keyPlanDataByCategoryCode =
        keyPlanByCategoryCodeResponse.data.entities.field_images[0];
      return keyPlanDataByCategoryCode;
    }
    return false;
  }

  /**
   * workGroupId変更時(日付、協力会社、職種、職長のいずれか変更)、
   * workGroupIdに紐づくkeyplan画像があればデータをセットし、なければクリアする
   */
  async updateKeyPlan() {
    const {
      field_tree_id,
      job_id,
      foreman_user_id,
      schedule_flag,
      work_date_from,
      work_date_to,
    } = this.state.formValues;
    // workGroupIdが決定できる時のみ実行
    if (
      !work_date_from ||
      !work_date_to ||
      !field_tree_id ||
      !job_id ||
      !foreman_user_id
    ) {
      return;
    }
    // 複数日にまたぐ場合はリセットする
    if (work_date_from !== work_date_to) {
      this.setState(prevState => ({
        image: {
          edited: false,
          json: '',
          keyplanId: '',
          path: '',
        },
        formValues: {
          ...prevState.formValues,
          work_key_plan_image: {},
        },
        isKeyPlanChanged: false,
        isSetExistingWorkGroupKeyPlan: false,
      }));
      return;
    }
    const workDate = work_date_from;
    const workHourZone = SessionStorageService.getItem('work_hour_zone');
    const existingKeyPlanResponse = await WorkScheduleService.getKeyPlanImage({
      fieldId: this.state.fieldId,
      fieldTreeId: field_tree_id,
      foremanUserId: foreman_user_id,
      jobId: job_id,
      workDate,
      workHourZone,
      scheduleFlag: schedule_flag,
    });
    if (existingKeyPlanResponse.result) {
      const workKeyPlanImage =
        existingKeyPlanResponse.data.entities.work_key_plan_image;

      // workGroupIdに紐づくkeyplan画像がない場合はデータをクリアする
      if (workKeyPlanImage === null) {
        this.setState(prevState => ({
          image: {
            edited: false,
            json: '',
            keyplanId: '',
            path: '',
          },
          formValues: {
            ...prevState.formValues,
            work_key_plan_image: {},
          },
          isKeyPlanChanged: false,
          isSetExistingWorkGroupKeyPlan: false,
        }));
        return;
      }

      let workKeyPlanState;
      // キープラン画像未編集の場合はedited_imageがnull
      if (workKeyPlanImage.edited_image === null) {
        const data = await this.getKeyPlanDataByCategoryCode(
          workKeyPlanImage.key_plan_category_code
        );
        workKeyPlanState = {
          path: data.image_url,
          json: null,
          edited: false,
          keyplanId: data.id,
        };
      } else {
        workKeyPlanState = {
          path: workKeyPlanImage.img_url,
          json: workKeyPlanImage.layout_json,
          keyplanId: workKeyPlanImage.id,
          edited: false,
        };
      }
      this.setState(prevState => ({
        image: workKeyPlanState,
        formValues: {
          ...prevState.formValues,
          work_key_plan_image: workKeyPlanImage,
        },
        isKeyPlanChanged: false,
        isSetExistingWorkGroupKeyPlan: true,
      }));
    }
  }

  closeConfirmDialog = () => {
    this.setState({
      isShowPopupError: false,
    });
  };

  showErrorDialog(message) {
    dialogLoader.show(ErrorDialog, {
      message,
      callback: {
        close: () => {
          dialogLoader.close();
        },
      },
    });
  }
  render() {
    const { loaded, isShowSptDropdown } = this.state;
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - 作業
            {this.props.isWorkSchedule ? '予定' : '実績'}新規作成
          </title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            dataTestId={
              this.props.isWorkSchedule
                ? 'work-schedule-regsiter'
                : 'work-result-register'
            }
            loaded={loaded}
            title={
              <div className='slide-view__title'>
                {this.props.isWorkSchedule
                  ? '作業予定新規作成'
                  : '作業実績新規作成'}
              </div>
            }
            loaderComponent={
              <div className='slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            leftComponent={
              <React.Fragment>
                <button
                  id='open-confirm-close'
                  className='btn--effective slide-view__header--button'
                  ref={this.submitRef}
                  onClick={() => {
                    // 重複登録防止
                    if (this.submitRef.current.disabled === false) {
                      this.events.form.submit();
                    }
                  }}
                >
                  登録
                </button>
                <button
                  className='btn slide-view__header--button'
                  ref={this.submitContinueRef}
                  onClick={() => {
                    // 重複登録防止
                    if (this.submitContinueRef.current.disabled === false) {
                      this.events.form.submit(true);
                    }
                  }}
                >
                  続けて登録
                </button>
              </React.Fragment>
            }
            rightComponent={
              <React.Fragment>
                <div className='slide-view__header-end-item'>
                  <div className='form-list__header-alert show'>
                    {this.state.validate.invalid
                      ? '入力エラーがあります。'
                      : this.state.apiErrorMessage !== ''
                      ? this.state.apiErrorMessage
                      : ''}
                  </div>
                </div>
                <div className='slide-view__header-end-item'>
                  {_.isNull(this.state.requiredInput.total)
                    ? ''
                    : `必須項目の入力数 ${this.state.requiredInput.count}/${
                        this.state.requiredInput.total
                      }`}
                </div>
              </React.Fragment>
            }
            onClose={() => this.events.dialog.goBack()}
          />
          <WorkScheduleForm
            companyItemOrders={this.state.companyItemOrders}
            companyItemSettings={this.state.companyItemSettings}
            values={this.state.formValues}
            isEdit={false}
            errors={this.state.validate.messages}
            workTime={this.state.workTime}
            isFifteen={this.state.isFifteen}
            isCopy={this.state.isCopy}
            roleId={this.state.roleId}
            image={this.state.image.path}
            imageJson={this.state.image.json}
            fieldItem={this.state.fieldItem}
            events={this.events}
            pulldownName={this.state.pulldownName}
            keyplanObserver={this.keyplanObserver.bind(this)}
            options={this.state.options}
            loaded={this.state.loaded}
            setLoadedKeyPlanData={this.setLoadedKeyPlanData}
            setValueMainWorkTypes={this.setValueMainWorkTypes}
            setValueSubWorkTypes={this.setValueSubWorkTypes}
            isShowMainSubDropdown={this.state.isShowMainSubDropdown}
            setWorkDateFrom={this.setWorkDateFrom}
            setWorkDateTo={this.setWorkDateTo}
            keySubWork={this.state.keySubWork}
            onLoadDataMain={this.getListMainWorkTypesData}
            onLoadDataSub={this.getListSubWorkTypesData}
            keyMainWork={this.state.keyMainWork}
            setListHistoriesMainWork={this.setListHistoriesMainWork}
            listHistoriesMain={this.listHistoriesMain}
            setListHistoriesSubWork={this.setListHistoriesSubWork}
            listHistoriesSub={this.listHistoriesSub}
            isFirstTimeGetHistories={this.isFirstTimeGetHistories}
            setFirstTimeGetHistories={this.setFirstTimeGetHistories}
            removeRequireSubAndWorkPlace={this.removeRequireSubAndWorkPlace}
            isWorkSchedule={this.props.isWorkSchedule}
            isShowSptDropdown={isShowSptDropdown}
          />
        </div>
        <LatestCopy
          show={this.state.modalVisible.copy}
          callbacks={this.events.dialog}
        />
        <Confirmation
          visible={this.state.isShowPopupError}
          title={messageUtility.getMessage('E-001-402')}
          message={messageUtility.getMessage('I-001-506')}
          confirmButtonText={messageUtility.getMessage('I-000-180')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={() => window.location.reload()}
          onCancel={() => this.closeConfirmDialog()}
          effectiveButtonClassName={'btn--sub'}
          multilineText={true}
        />
      </div>
    );
  }
}

/**
 * 前回コピーダイアログ
 */
class LatestCopyDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>前回登録した内容をコピー</span>
        </div>
        <div className='dialog-md__body text-center'>
          <p>現在編集中のデータを上書きします。よろしいですか？</p>
          <p>※この操作は取り消せません。</p>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn'
            onClick={() => {
              this.props.dialog.callback.copy();
            }}
          >
            コピーする
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 続けて登録ダイアログ
 */
class ContinuityDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__body text-center'>
          {this.props.dialog.isWorkSchedule ? '予定' : '実績'}を登録しました。
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

export default WorkRegister;



// WEBPACK FOOTER //
// ./src/pages/WorkRegister.jsx